import React, {useState, useEffect} from 'react';
import {RouteComponentProps, Redirect, Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import {Inc,Owner} from './Inc';
import Ajax from './Ajax';
import Loading from './Loading';
import Title from './Title';

interface RCProps extends RouteComponentProps<{id:string}> {
	
}

interface Props {
	owner:Owner,
}

interface Total {
    plus: string,
    minus: string,
    uri: string,
    zan: string,
    count: string,
}

const ZaikoDetail = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const rcp:RCProps = useReactRouter();

    const classes = useStyles();
    const defTotal:Total = {
        plus: "",
        minus: "",
        uri: "",
        zan: "",
        count: "",
    };
    const [states,setStates] = useState({
        zaikos:[],
        total:defTotal,
        item:Inc.defaultItem(),
        isLoading:true,
        notFound: false,
    });
    const search = ()=>{
        Ajax.send("zaiko/detail",{item_id:rcp.match.params.id},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({zaikos:res.zaikos,item:res.item,total:res.total,isLoading:false,notFound:false});
            } else {
                //setStates({...states,"isLoading":false,notFound:true});
            }
        });
    }
    useEffect( ()=>{
        search();
    },[]);

    if( states.notFound ){
		if( props.owner.owner_id===0 ){
	        return (
    	        <Redirect to="/profile"/>
        	);
		} else {
	        return (
    	        <Redirect to="/"/>
        	);
		}
    }

	return (
		<div id="zaiko_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="在庫の変動履歴" icon="cart"/>
                        <div style={{marginBottom:"1em"}}>
                            <span className={classes.itemId}>ID: {states.item.item_id}</span> {states.item.item_name} の在庫数の変動履歴（{states.total.count}件）を表示中です。
                        </div>
                        <div style={{textAlign:"right",marginBottom:"1em"}}>
                            <Link to="/zaiko"><Button variant="outlined" color="primary">別の商品を見る</Button></Link>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>年</TableCell>
                                    <TableCell className={classes.tableCellNowrap}>月</TableCell>
                                    <TableCell className={classes.tableCellNowrap}>日</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellNowrap}>商品</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableCellNowrap}>納品</TableCell>
                                    <TableCell className={classes.tableCellNowrap}>返品</TableCell>
                                    <TableCell className={classes.tableCellNowrap}>売上</TableCell>
                                    <TableCell className={classes.tableCellNowrap}>在庫</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {states.zaikos.map( (zaiko:any,index:number)=>{
                            const key = "zaiko"+index;
                            return (
                                <TableRow key={key}>
                                    <TableCell className={classes.tableCellDense}>{zaiko.year}</TableCell>
                                    <TableCell className={classes.tableCellDense}>{zaiko.month}</TableCell>
                                    <TableCell className={classes.tableCellDense}>{zaiko.day}</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellDense}>
                                            <span className={classes.itemId}>ID:{states.item.item_id}</span>　
                                            {states.item.item_name}
                                        </TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableCellDense} align="right">{zaiko.plus}</TableCell>
                                    <TableCell className={classes.tableCellDense} align="right">{zaiko.minus}</TableCell>
                                    <TableCell className={classes.tableCellDense} align="right">{zaiko.uri}</TableCell>
                                    <TableCell className={classes.tableCellDense} align="right">{zaiko.zan}</TableCell>
                                </TableRow>
                            );
                        })}
                                <TableRow key="total">
                                    <TableCell className={classes.tableCellDense}>合計</TableCell>
                                    <TableCell className={classes.tableCellDense}></TableCell>
                                    <TableCell className={classes.tableCellDense}></TableCell>
                                    <Hidden smDown implementation="js">
                                    <TableCell className={classes.tableCellDense}></TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableCellDense} align="right">{states.total.plus}</TableCell>
                                    <TableCell className={classes.tableCellDense} align="right">{states.total.minus}</TableCell>
                                    <TableCell className={classes.tableCellDense} align="right">{states.total.uri}</TableCell>
                                    <TableCell className={classes.tableCellDense} align="right">{states.total.zan}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>
            </Grid>
            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default ZaikoDetail;
